import { render, staticRenderFns } from "./OrderArchitecturePage.vue?vue&type=template&id=fc45c378&scoped=true&"
import script from "./OrderArchitecturePage.vue?vue&type=script&lang=js&"
export * from "./OrderArchitecturePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc45c378",
  null
  
)

export default component.exports